import { Button } from "@material-ui/core"
import { useHistory } from "react-router-dom";
export const ButtonClienteDetalle = ({ referencia, iswhite = false }) => {
    const history = useHistory()
    const handleClick = () => {
        history.push(`/Cliente/${referencia}`, {
            reservas: true
        })
    }
    return (
        <Button onClick={handleClick} style={{ color: (iswhite) ?  "white" : "balack"}}>
            {referencia}
        </Button>
    )
}
export default ButtonClienteDetalle